/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadFileSpec
 */
export interface UploadFileSpec {
    /**
     * 
     */
    filename: string;
    /**
     * 
     */
    contentType: string;
}

/**
 * Check if a given object implements the UploadFileSpec interface.
 */
export function instanceOfUploadFileSpec(value: object): value is UploadFileSpec {
    if (!('filename' in value) || value['filename'] === undefined) return false;
    if ((!('contentType' in (value as Record<string, any>)) && !('content_type' in (value as Record<string, any>))) || ((value as Record<string, any>)['contentType'] === undefined && (value as Record<string, any>)['content_type'] === undefined)) return false;
    return true;
}

export function UploadFileSpecFromJSON(json: any): UploadFileSpec {
    return UploadFileSpecFromJSONTyped(json, false);
}

export function UploadFileSpecFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadFileSpec {
    if (json == null) {
        return json;
    }
    return {
        
        'filename': json['filename'],
        'contentType': json['content_type'],
    };
}

export function UploadFileSpecToJSON(json: any): UploadFileSpec {
    return UploadFileSpecToJSONTyped(json, false);
}

export function UploadFileSpecToJSONTyped(value?: UploadFileSpec | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'filename': value['filename'],
        'content_type': value['contentType'],
    };
}

